import React, { useState } from 'react'
import { useParams } from 'react-router-dom'
import { useForm, Controller } from 'react-hook-form'
import { isEmpty } from 'lodash'
import classNames from 'classnames'
import { FaEye, FaEyeSlash } from 'react-icons/fa'
import fontStyles from 'src/assets/styles/fontStyles.module.scss'
import generalStyles from 'src/assets/styles/generalStyles.module.scss'
import Input from 'src/components/Elements/Inputs/Input'
import useUpdatePassword from 'src/queries/auth/useUpdatePassword'
import Button from 'src/components/Elements/Button'
import preloginStyles from './prelogin.module.scss'

const ChangeTempPasswordForm = () => {
  const { token } = useParams()
  const { mutateAsync } = useUpdatePassword()
  const [loginError, setLoginError] = useState('')
  const [showPasswordOne, setShowPasswordOne] = useState(false)
  const [showPasswordTwo, setShowPasswordTwo] = useState(false)

  const IconComponentOne = showPasswordOne ? FaEye : FaEyeSlash
  const IconComponentTwo = showPasswordTwo ? FaEye : FaEyeSlash

  const {
    handleSubmit,
    control,
    formState: { errors, isValid }
  } = useForm({
    mode: 'onChange',
    defaultValues: {
      passwordOne: '',
      passwordTwo: ''
    }
  })

  const submitEmailForm = async (data) => {
    const userObj = token
      ? {
        reset_password_token: token,
        password: data.passwordOne,
        password_confirmation: data.passwordTwo
      }
      : {
        new_password: data.passwordOne,
        confirmation_password: data.passwordTwo
      }
    const login = await mutateAsync({ ...userObj })
    if (login.status !== 200) {
      if (login.status === 403) {
        setLoginError(
          'Token has expired, <a href="/auth/forgot-password">click here</a> to receive a new token.'
        )
      } else {
        const errorMessage = Object.values(login.data?.errors || {})[0]?.[0]
        if (!isEmpty(errorMessage)) {
          setLoginError(
            errorMessage === 'account_disabled'
              ? 'Account disabled.'
              : 'Invalid login credentials'
          )
        }
      }
    }
  }

  return (
    <div
      key="changePasswordForm"
      className={classNames(
        preloginStyles.contentBodyContainer,
        generalStyles.flexApart,
        preloginStyles.changeTempPwForm
      )}
    >
      <div className={generalStyles.pt50}>
        <div className={generalStyles.mb30}>
          <span className={fontStyles.h3lsgartnersans32pt}>Change Password</span>
        </div>
        <Controller
          name="passwordOne"
          control={control}
          rules={{
            required: {
              value: true
            },
            minLength: {
              value: 8
            }
          }}
          render={({ field: { onChange, onBlur, value } }) => (
            <div className={classNames(generalStyles.flexRow)}>
              <Input
                id="passwordOne"
                label={{ label: 'New Password', placeholder: 'New Password' }}
                name="passwordOne"
                type={showPasswordOne ? 'text' : 'password'}
                icon={{ name: 'Password', size: 27 }}
                onBlur={onBlur}
                value={value}
                fullWidth
                onChange={(text) => onChange(text)}
              />
              <IconComponentOne
                data-testid="passwordOneVisibilityToggle"
                style={{ marginTop: 15 }}
                onClick={() => setShowPasswordOne(!showPasswordOne)}
              />
            </div>
          )}
        />
        <Controller
          name="passwordTwo"
          control={control}
          rules={{
            required: {
              value: true
            },
            minLength: {
              value: 8
            },
            validate: {
              match: (value, formValues) => value === formValues.passwordOne
            }
          }}
          render={({ field: { onChange, onBlur, value } }) => (
            <div className={classNames(generalStyles.mt20, generalStyles.flexRow)}>
              <Input
                id="passwordTwo"
                label={{
                  label: 'Re-enter New Password',
                  placeholder: 'Re-enter New Password'
                }}
                name="passwordTwo"
                type={showPasswordTwo ? 'text' : 'password'}
                icon={{ name: 'Password', size: 27 }}
                onBlur={onBlur}
                value={value}
                fullWidth
                onChange={(text) => onChange(text)}
                error={
                  errors?.passwordTwo || loginError
                    ? loginError || 'Passwords do not match'
                    : null
                }
              />
              <IconComponentTwo
                data-testid="passwordTwoVisibilityToggle"
                style={{ marginTop: 15 }}
                onClick={() => setShowPasswordTwo(!showPasswordTwo)}
              />
            </div>
          )}
        />
        <div className={generalStyles.mt20}>
          <span className={fontStyles.pxsmallboldlsssinneutral08onyxgartnersans12pt}>
            Passwords must be a minimum of eight characters in length.
          </span>
        </div>
      </div>
      <div>
        <Button
          color={isValid ? 'lightBase' : 'lightBaseOutline'}
          size="large"
          onClick={handleSubmit(submitEmailForm)}
          label="Submit"
          disabled={!isValid}
        />
      </div>
    </div>
  )
}

export default ChangeTempPasswordForm
